import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApproveMultipleService } from '../../services/approve-multiple.service';

@Component({
  selector: 'app-approve-multiple',
  templateUrl: './approve-multiple.component.html',
  styleUrls: ['./approve-multiple.component.scss']
})
export class ApproveMultipleComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<ApproveMultipleComponent>,
    @Inject(MAT_DIALOG_DATA) public idArray: string[],
    private approveMultipleService: ApproveMultipleService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

async  approve(){
  try{
    await this.approveMultipleService.approveMultipleSecondHandSupply(this.idArray);
    this.closeDialog('yes');
    this.toast.openSnackBar("Products are approved");
  }catch(error){
    this.toast.openSnackBar("Unable to approve");
  }


  }
}





